import React from 'react';
import { FaComments, FaRocket, FaBolt, FaShieldAlt, FaFeatherAlt, FaLayerGroup } from 'react-icons/fa';
import { SiGoogle, SiOpenai, SiClaude, SiTelegram, SiWhatsapp, SiDiscord } from 'react-icons/si';
import StaticParticles from '../StaticParticles/StaticParticles';
import './Module1Card.css';

const Module1Card = ({ 
  onClick,
  particlesCount = 300,          // количество частиц
  particlesOpacity = 0.6,        // прозрачность частиц
  particlesSway = 0.5            // покачивание (0-1)
}) => {
  return (
    <div className="module1-card" onClick={onClick}>
      {/* Canvas частицы */}
      <StaticParticles 
        count={particlesCount}
        color="#06B6D4"
        opacity={particlesOpacity}
        sway={particlesSway}
      />
      
      {/* Голубая рамка */}
      <div className="cyan-border"></div>
      
      {/* Основной контент */}
      <div className="card-content">
        
        {/* Верхняя секция: Заголовок слева + Ноутбук справа */}
        <div className="top-section">
          
          {/* Левая часть - текст */}
          <div className="text-section">
            <div className="module-label"></div>
            <h2 className="main-title">
              Browser Proctor <span className="cyan-text">Bypass</span>
            </h2>
            <p className="description">
              ℹ️ Works on DEFAULT browser (not Safe Browser)
            </p>
          </div>
          
          {/* Правая часть - ноутбук */}
          <div className="laptop-section">
            <div className="laptop-wrapper">
              {/* Голубые trails */}
              <div className="cyan-trail trail-1"></div>
              <div className="cyan-trail trail-2"></div>
              <div className="cyan-trail trail-3"></div>
              
              <img 
                src={`${process.env.PUBLIC_URL}/images/lap.webp`}
                alt="Laptop" 
                className="laptop-img"
              />
            </div>
          </div>
          
        </div>
        
        {/* Карточки фич */}
        <div className="features-row">
          
          <div className="feature-box">
            <div className="feature-icon-circle">
              <FaBolt className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">Fast Setup</h4>
              <p className="feature-desc">~5 min vs Module 2: hours</p>
            </div>
          </div>
          
          <div className="feature-box">
            <div className="feature-icon-circle">
              <FaShieldAlt className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">Maximum Stealth</h4>
              <p className="feature-desc">Minimal footprint, hard to detect</p>
            </div>
          </div>
          
          <div className="feature-box">
            <div className="feature-icon-circle">
              <FaFeatherAlt className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">Ultra Light</h4>
              <p className="feature-desc">12-30MB vs Module 2: ~2GB</p>
            </div>
          </div>
          
        </div>
        
        {/* Integrated Applications */}
        <div className="apps-section">
          <div className="apps-header">
            <FaLayerGroup className="apps-icon" />
            <span className="apps-label">Access Applications:</span>
          </div>
          <div className="apps-badges">
            <div className="app-badge"><SiGoogle className="badge-icon badge-icon-color" /> Google</div>
            <div className="app-badge"><SiOpenai className="badge-icon badge-icon-color" /> ChatGPT</div>
            <div className="app-badge"><SiClaude className="badge-icon badge-icon-color" /> Claude</div>
            <div className="app-badge"><SiTelegram className="badge-icon badge-icon-color" /> TG</div>
            <div className="app-badge"><SiWhatsapp className="badge-icon badge-icon-color" /> WhatsApp</div>
            <div className="app-badge"><SiDiscord className="badge-icon badge-icon-color" /> Discord</div>
            <div className="app-badge highlight"><FaComments className="badge-icon" /> Any messengers</div>
            <div className="app-badge highlight"><FaRocket className="badge-icon" /> Any applications</div>
          </div>
        </div>
        
        {/* CTA Button */}
        <button className="details-button">
          View Full Technical Details →
        </button>
        
      </div>
     
      
    </div>
  );
};

export default Module1Card;
